// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Colors (palette)*/
  --alpha: 0.3;
  --col-black: rgb(20, 20, 20);
  --col-light-grey: rgb(211, 211, 211);
  --col-dark-grey: rgb(65, 65, 65);
  --col-white: rgb(255, 255, 255);
  --col-rain: rgb(0, 102, 204);
  --col-white-alpha: rgb(255, 255, 255, var(--alpha));
  --col-white-alpha-x2: rgb(255, 255, 255, calc(var(--alpha) * 2));
  --col-alert: var(--col-white);
  --col-alert-bg: rgba(220, 53, 69, 0.6);

  /* Colors (background)*/
  --bg-col: rgb(227, 248, 242);
  --block-bg-col: rgb(215, 240, 233);
  --col-highlight: rgb(188, 224, 232);
  --weather-data-page-bg: linear-gradient(
    to bottom,
    var(--bg-col),
    var(--col-dark-grey)
  );
  --block-bg-color: var(--col-white-alpha);
  --main-grey: var(--col-dark-grey);

  /* Colors (text/icons)*/
  --col-txt: var(--col-black);
  --col-txt-alt: var(--col-white);

  /* Colors (icons)*/

  /* Font family */
  --main-font: "Nunito", sans-serif;

  /* Font sizes */
  --txt-fontsize: 18px;
  --txt-small-fontsize: 0.8em;
  --txt-smaller-fontsize: 0.6em;
  --txt-lineheight: 1.2;
  --h1-font-size: 1.2rem;
  --h2-font-size: 2em;
  --h3-font-size: 1.1em;
  --h3-alert-font-size: 2em;
  --h3-icon-size: 3em;
  --h4-alert-font-size: var(--h3-font-size);
  --weather-icon-size: 9em;
  --weather-icon-mini-size: 2.5em;
  --weather-icon-mid-size: 5em;
  --temp-font-size: 5rem;
  --temp-font-size-small: 4rem;
  --temp-font-size-smaller: 3rem;
  --other-condition-value-fontsize: 3.5em;
  --other-condition-unit-fontsize: 1em;
  --other-condition-small-fontsize: 0.8em;
  --other-condition-smaller-fontsize: 0.6em;
  --generic-icon-size: 2rem;
  --select-location-text-size: 1.2em;

  /* Text clamping: number of lines */
  --alert-max-lines: 4;

  /* Maximum width (including dashboard margin) */
  --max-width: min(1440px, 100%);

  /* Radius */
  --radius: 30px;
  --radius-inner: 25px;

  /*Margins, gaps and paddings (+widths)*/
  --page-padding: 1em;
  --page-gap: var(--page-padding);
  --block-alt-padding: 1em;
  --block-half-alt-padding: calc(var(--block-alt-padding) / 2);
  --block-alt-gap: var(--block-half-alt-padding);
  --block-padding: calc(var(--radius) / 2);
  --block-padding-inner: calc(var(--radius-inner) / 2);
  --block-gap: 0.4em;
  --block-gap-larger: 0.8em;
  --select-location-padding: 0.5em 1em;
  --select-location-gap: 1em;
  --footer-padding: 3rem;
  --footer-gap: 2rem;

  /* Images / icons size */

  /* Shadows */
  /* --outset-shadow: 2px 2px 8px var(--col-accent-medium);
    --outset-shadow-btn-active: 2px 2px 5px var(--col-accent-medium);
    --inset-shadow: 2px 2px 2px var(--col-accent-light) inset; */

  /* Animations on hover / active / ...*/
  /* --transition-time: 0.8s; */
}

html {
  background-color: var(--bg-col);
  color: var(--col-txt);
  font-family: var(--main-font), sans-serif;
  font-weight: 400;
  font-size: var(--txt-fontsize);
  line-height: var(--txt-lineheight);
}

html:has(.weather-data-page) {
  background: var(--weather-data-page-bg);
  background-attachment: fixed;
}

*,
*:before,
*:after {
  font-family: inherit;
  font-size: inherit; /* 100% */
  line-height: inherit;
  color: inherit;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  vertical-align: baseline;
  -webkit-tap-highlight-color: transparent;
}

body {
  margin: 0 auto;
  height: 100vh; /*it is assumed the same for <html>*/
  height: 100dvh; /* if supported */

  /* if you want to allow scroll: */
  /* min-height: 100vh; */
  /* height: 100%; */

  width: 100%;
  /* or max-width -- this avoids horizontal scroll bars */

  touch-action: manipulation; /* disable double tap to zoom on some browsers*/
  user-select: none;
}

/*****************************************************/

/* || Generic */

body {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
}

body > * {
  width: 100%;
}

main {
  width: 100%;
  max-width: var(--max-width);
  min-height: 100dvh;
  flex-shrink: 0;
  margin: 0 auto;
}

p {
  text-wrap: pretty;
}

ul,
ol {
  list-style: none;
}

a,
a:hover,
a:active,
a:visited {
  text-decoration: none;
}

button,
.weather-data-page__day-forecasts-li {
  cursor: pointer;
}

/* HEADERS */

.select-location-page,
.settings-page,
.fetching-page,
.error-page,
.locating-page {
  padding: var(--page-padding);
  display: flex;
  flex-direction: column;
  gap: var(--page-gap);
}

.select-location-page__header,
.settings-page__header,
.error-page__header,
.fetching-page__header,
.locating-page__header {
  display: grid;
  grid-template-columns: var(--generic-icon-size) 1fr var(--generic-icon-size);
  grid-template-rows: max(var(--h1-font-size), var(--generic-icon-size));
  align-items: center;
  justify-items: center;
  line-height: 1;
}

.select-location-page__h1,
.settings-page__h1,
.fetching-page__h1,
.error-page__h1,
.locating-page__h1 {
  font-size: var(--h1-font-size);
  grid-column: 2;
}

/* SELECT LOCATION PAGE --------------------------------------------------------- */

.select-location-page__bookmarked-list {
  display: flex;
  flex-direction: column;
  gap: var(--block-gap);
}

.select-location-page__search-div,
.select-location-page__home-div,
.select-location-page__bookmarked-div,
.select-location-page__current-location-div {
  background-color: var(--block-bg-col);
  border-radius: var(--radius);
  /* padding: var(--block-padding); */
  gap: var(--block-gap);
  display: flex;
}

.select-location-page__search-icon,
.select-location-page__remove-home-btn,
.select-location-page__remove-bookmarked-btn,
.select-location-page__current-location-icon {
  margin: var(--block-padding);
  margin-right: 0;
}

.select-location-page__search-input,
.select-location-page__home-btn,
.select-location-page__bookmarked-btn,
.select-location-page__current-location-btn {
  font-size: var(--select-location-text-size);
  border: none;
  background: none;
  text-align: left;
  justify-content: pretty;
  padding: var(--block-padding);
  padding-left: 0;
  width: 100%;
}

.select-location-page__search-input {
  padding: 0;
  margin: var(--block-padding);
  margin-left: 0;
}

.select-location-page__search-input {
  width: 100%;
  border-bottom: 1px solid var(--bg-col);
}
.select-location-page__search-input::placeholder {
  color: var(--col-light-grey);
}
.select-location-page__search-input:focus {
  /* border: none; */
  outline: none;
}

.select-location-page__remove-home-btn,
.select-location-page__remove-bookmarked-btn {
  flex-basis: calc(var(--generic-icon-size));
  flex-shrink: 0;
}

/* SETTINGS PAGE --------------------------------------------------------- */
/* See also: https://moderncss.dev/pure-css-custom-styled-radio-buttons/*/

.settings-page__h2 {
  text-align: center;
}

.settings-page__units-fieldset {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
}

.settings-page__enable-animations-item-div,
.settings-page__units-fieldset {
  border-radius: var(--radius);
  padding: var(--block-padding);
  background-color: var(--block-bg-col);
  border: none;
}

.settings-page__enable-animations-item-label,
.settings-page__units-item-label {
  width: 100%;
}

.settings-page__units-fieldset-legend {
  border-radius: var(--radius);
  padding: var(--block-padding-inner);
  background-color: var(--col-white);
  border: none;
  font-weight: bold;
}

.settings-page__enable-animations-item-div,
.settings-page__units-item-div {
  display: grid;
  grid-template-columns: 1em auto;
  gap: 0.5em;
  font-size: var(--select-location-text-size);
}

input[type="radio"],
input[type="checkbox"] {
  user-select: none;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  background-color: var(--col-white);
  margin: 0;
  font: inherit;
  color: var(--col-white);
  width: 1.15em;
  height: 1.15em;
  border: 0.15em solid var(--col-white);
  transform: translateY(-0.075em);
  display: flex;
  align-items: center;
  justify-content: center;
}

input[type="radio"]::before,
input[type="checkbox"]::before {
  content: "";
  width: 0.65em;
  height: 0.65em;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em var(--col-txt);
  /* Windows High Contrast Mode */
  background-color: CanvasText;
}

input[type="radio"]:checked::before,
input[type="checkbox"]:checked::before {
  transform: scale(1);
}

input[type="radio"]:focus,
input[type="checkbox"]:focus {
  border-color: var(--col-txt);
  outline: none;
}

input[type="radio"],
input[type="radio"]::before {
  border-radius: 50%;
}
input[type="checkbox"],
input[type="checkbox"]::before {
  border-radius: 20%;
}

/* WEATHER DATA PAGE ------------------------------------------------------------ */

.weather-data-page {
  padding: var(--page-padding);
  display: flex;
  flex-direction: column;
  gap: var(--page-gap);
  padding-bottom: var(--footer-padding);
}

.weather-data-page__header {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;
  gap: var(--page-gap);
}

.weather-data-page__btn-div {
  display: grid;
  grid-template-areas: "back time time time home bookmarked refresh";
  grid-template-columns:
    var(--generic-icon-size) var(--generic-icon-size) var(--generic-icon-size)
    1fr
    var(--generic-icon-size) var(--generic-icon-size) var(--generic-icon-size);
  grid-template-rows: max(var(--h1-font-size), var(--generic-icon-size));
  align-items: center;
  justify-items: center;
  line-height: 1;
  width: 100%;
}

.weather-data-page.daily .weather-data-page__btn-div {
  grid-template-areas: "back daily-forecast daily-forecast daily-forecast daily-forecast daily-forecast .";
}

@media only screen and (min-width: 641px) {
  .weather-data-page__btn-div {
    grid-template-areas: "back . . time home bookmarked refresh";
  }
}

.weather-data-page__last-update-time {
  grid-area: time;
}

.weather-data-page__daily-forecast-p {
  grid-area: daily-forecast;
}

.weather-data-page__back-btn {
  grid-area: back;
}

.weather-data-page__refresh-btn {
  grid-area: refresh;
}

.weather-data-page__toggle-home-btn {
  grid-area: home;
}

.weather-data-page__toggle-bookmarked-btn {
  grid-area: bookmarked;
}

.weather-data-page__location {
  display: flex;
  flex-direction: column;
}

.weather-data-page__location-h2 {
  font-size: var(--h2-font-size);
  text-align: center;
  text-wrap: balance;
}

/* CURRENT CONDITION */

.weather-data-page.night {
  --alpha: 0.5;
  --col-white-alpha: rgb(255, 255, 255, var(--alpha));
  --block-bg-color: var(--col-white-alpha);
  --main-grey: var(--col-light-grey);
}

.weather-data-page.night .weather-data-page__header,
.weather-data-page.night .weather-data-page__current-condition-div,
.weather-data-page.night .weather-data-page__daily-condition-div {
  color: var(--col-txt-alt);
}

.weather-data-page__current-condition-div,
.weather-data-page__daily-condition-div {
  display: grid;
  padding: var(--block-alt-padding);
  gap: var(--block-alt-gap) 0px;
  align-items: center;
  justify-items: center;
  justify-content: center;
  line-height: 1;
}

.weather-data-page__current-condition-div {
  grid-template-areas:
    "conditions conditions"
    "icon temp"
    "feelslike feelslike"
    "lowhightemp lowhightemp";
  grid-template-rows: max-content max-content max-content max-content;
  grid-template-columns: max-content max-content;
}

.weather-data-page__daily-condition-div {
  grid-template-areas:
    "date date"
    "conditions conditions"
    "icon hightemp"
    "icon lowtemp";
  grid-template-rows: max-content max-content max-content max-content;
  grid-template-columns: max-content max-content;
}

.weather-data-page__conditions-p {
  grid-area: conditions;
  color: var(--main-grey);
}

.weather-data-page__date-p {
  grid-area: date;
  font-weight: bold;
}

.weather-data-page__temp-p {
  grid-area: temp;
  justify-self: start;
  font-size: var(--temp-font-size-small);
  letter-spacing: -4px;
  font-weight: bold;
}

.weather-data-page__high-temp-p {
  grid-area: hightemp;
  justify-self: start;
  align-self: end;
  font-size: var(--temp-font-size-small);
  letter-spacing: -4px;
  font-weight: bold;
}

.weather-data-page__low-temp-p {
  margin-top: calc(-1 * var(--block-alt-gap) / 2);
  grid-area: lowtemp;
  justify-self: start;
  align-self: start;
  font-size: var(--temp-font-size-smaller);
  letter-spacing: -3px;
  color: var(--main-grey);
}

@media only screen and (min-width: 641px) {
  .weather-data-page__daily-condition-div {
    grid-template-areas:
      "date date date"
      "conditions conditions conditions"
      "icon hightemp lowtemp";
    grid-template-rows: max-content max-content max-content;
    grid-template-columns: max-content max-content max-content;
  }

  .weather-data-page__temp-p,
  .weather-data-page__high-temp-p {
    font-size: var(--temp-font-size);
    letter-spacing: -5px;
  }

  .weather-data-page__low-temp-p {
    margin-top: 0;
    font-size: var(--temp-font-size-small);
    letter-spacing: -4px;
  }

  .weather-data-page__low-temp-p,
  .weather-data-page__high-temp-p {
    align-self: center;
  }

  .weather-data-page__low-temp-p::before {
    content: "\\00a0/\\00a0";
    font-size: var(--temp-font-size-small);
    letter-spacing: -4px;
  }
}

.weather-data-page__icon-div {
  grid-area: icon;
  justify-self: end;
  width: var(--weather-icon-size);
  height: var(--weather-icon-size);
}

.weather-data-page__feels-like-p {
  grid-area: feelslike;
}

.weather-data-page__high-low-temp-p {
  grid-area: lowhightemp;
}

/* ALERTS */

.weather-data-page__alerts-div {
  display: grid;
  grid-template-areas:
    "icon titleh3"
    "list list";
  grid-template-rows: max-content 1fr;
  grid-template-columns: max-content 1fr;
  background-color: var(--col-alert-bg);
  border-radius: var(--radius);
  padding: var(--block-padding);
  gap: var(--block-padding) 0;

  grid-template-areas:
    " titleh3 icon"
    "list list";
  grid-template-columns: 1fr max-content;
}

.weather-data-page__alerts-icon-div {
  grid-area: icon;
  align-self: center;
  width: var(--h3-icon-size);
  height: var(--h3-icon-size);
}

.weather-data-page__alerts-icon-div path svg {
  height: 100%;
  width: 100%;
}

.weather-data-page__alerts-icon-div path {
  fill: var(--col-alert);
  stroke: var(--col-alert);
}

.weather-data-page__alerts-h3 {
  grid-area: titleh3;
  color: var(--col-alert);
  font-weight: normal;
  font-size: var(--h3-alert-font-size);
  line-height: 1;
  align-self: center;
  margin-left: var(--block-padding-inner);
}

.weather-data-page__alerts-list {
  grid-area: list;
  display: flex;
  flex-direction: column;
  gap: var(--block-alt-gap);
}

.weather-data-page__alert-li {
  display: flex;
  flex-direction: column;
  background-color: var(--block-bg-color);
  border-radius: var(--radius-inner);
  padding: var(--block-padding-inner);
  gap: var(--block-gap);
}

.weather-data-page__alert-header {
  display: flex;
  justify-content: space-between;
  height: min-content;
}

.weather-data-page__alert-h4 {
  font-size: var(--h4-alert-font-size);
}

.weather-data-page__alert-date-p {
  color: var(--col-dark-grey);
  font-size: var(--txt-small-fontsize);
  text-align: right;
  text-wrap: balance;
}

.weather-data-page__alert-descr-p {
  text-wrap: pretty;
  /* Break links */
  /* From: https://stackoverflow.com/questions/5241369/word-wrap-a-link-so-it-doesnt-overflow-its-parent-div-width */

  /* Warning: Needed for oldIE support, but words are broken up letter-by-letter */
  -ms-word-break: break-all;
  word-break: break-all;
  /* Non standard for webkit */
  word-break: break-word;
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
}

.weather-data-page__alert-li.clamp .weather-data-page__alert-descr-p {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: auto;
  line-clamp: var(--alert-max-lines);
  -webkit-line-clamp: var(--alert-max-lines);
}

/* GENERIC BLOCKS */

.weather-data-page__weather-insight-div,
.weather-data-page__hourly-forecasts-div,
.weather-data-page__daily-forecasts-div {
  display: flex;
  flex-direction: column;
  background-color: var(--block-bg-color);
  border-radius: var(--radius);
  padding: var(--block-padding);
  gap: var(--block-gap);
  user-select: none;
}

.weather-data-page__weather-insight-h3,
.weather-data-page__hourly-forecasts-h3,
.weather-data-page__daily-forecasts-h3 {
  font-size: var(--h3-font-size);
}

.weather-data-page.daily .weather-data-page__daily-forecasts-div {
  background: none;
  padding: 0;
}

.weather-data-page.daily .weather-data-page__daily-forecasts-h3 {
  display: none;
}

/* HOURLY / DAILY FORECASTS */

.weather-data-page__hourly-forecasts-list,
.weather-data-page__daily-forecasts-list {
  display: flex;
  gap: var(--block-gap-larger);
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: var(--block-gap);
  justify-content: space-between;
}

.weather-data-page__daily-forecasts-list {
  gap: var(--block-alt-gap);
}

.weather-data-page__hour-forecasts-li,
.weather-data-page__day-forecasts-li {
  display: grid;
  align-items: start;
  justify-items: center;
}

.weather-data-page__hour-forecasts-li {
  grid-template-areas:
    "temp"
    "icon"
    "precipprob"
    "time";
  grid-template-rows: repeat(4, max-content);
  grid-template-columns: repeat(24, min-content);
}

.weather-data-page__day-forecasts-li {
  grid-template-areas:
    "temp"
    "templow"
    "icon"
    "precipprob"
    "time"
    "date";
  grid-template-rows: repeat(6, max-content);
  grid-template-columns: repeat(15, min-content);
  background-color: var(--col-white-alpha);
  border-radius: calc(var(--radius-inner));
  padding: var(--block-padding-inner);
  user-select: none;
}

.weather-data-page__hour-forecasts-temp,
.weather-data-page__day-forecasts-temp-high {
  grid-area: temp;
  font-weight: bold;
}

.weather-data-page__day-forecasts-temp-low {
  grid-area: templow;
  font-size: var(--txt-small-fontsize);
}

.weather-data-page__hour-forecasts-icon-div,
.weather-data-page__day-forecasts-icon-div {
  grid-area: icon;
  width: var(--weather-icon-mini-size);
  height: var(--weather-icon-mini-size);
}

.weather-data-page__hour-forecasts-precip-prob,
.weather-data-page__day-forecasts-precip-prob {
  grid-area: precipprob;
  color: var(--col-rain);
  font-size: var(--txt-smaller-fontsize);
  height: calc(var(--txt-smaller-fontsize) * var(--txt-lineheight));
}

.weather-data-page__hour-forecasts-hour,
.weather-data-page__day-forecasts-day {
  grid-area: time;
  font-size: var(--txt-small-fontsize);
  padding-top: var(--block-gap-larger);
}

.weather-data-page__day-forecasts-date {
  grid-area: date;
  font-size: var(--txt-smaller-fontsize);
}

/* OTHER INFO FORECASTS */

.weather-data-page__other-conditions-list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--block-gap-larger);
  /* align-items: flex-start; */
}

.weather-data-page__other-condition-li {
  display: flex;
  flex-direction: column;
  background-color: var(--block-bg-color);
  border-radius: var(--radius);
  padding: var(--block-padding);
  gap: var(--block-gap);
  user-select: none;
  width: max-content;
  flex: 1;
  /* max-width: fit-content; */
  align-items: center;
  justify-content: space-between;
}

.weather-data-page__other-condition-li:has(.flex-list) {
  flex: 3;
}

.weather-data-page__other-condition-h3 {
  font-size: var(--h3-font-size);
  text-align: center;
}

.weather-data-page__other-condition-content {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.weather-data-page__other-condition-icon-div {
  width: var(--weather-icon-mid-size);
  height: min-content;
  z-index: -1;
}

.weather-data-page__other-condition-value-div {
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: baseline;
}

.weather-data-page__other-condition-value {
  font-weight: bold;
  font-size: var(--other-condition-value-fontsize);
}

.x3 .weather-data-page__other-condition-value {
  font-size: calc(var(--other-condition-value-fontsize) / 1.3);
}

.x4 .weather-data-page__other-condition-value {
  font-size: calc(var(--other-condition-value-fontsize) / 1.6);
}

.x5 .weather-data-page__other-condition-value {
  font-size: calc(var(--other-condition-value-fontsize) / 2);
}

.weather-data-page__other-condition-value-unit {
  font-size: var(--other-condition-unit-fontsize);
}

.x3 .weather-data-page__other-condition-value-unit,
.x4 .weather-data-page__other-condition-value-unit {
  font-size: calc(var(--other-condition-unit-fontsize) / 1);
}

.x5 .weather-data-page__other-condition-value-unit {
  font-size: calc(var(--other-condition-unit-fontsize) / 1);
}

.weather-data-page__other-condition-value-small-div {
  font-size: var(--other-condition-small-fontsize);
  display: flex;
  gap: 0.2em;
  width: max-content;
}

.weather-data-page__other-condition-icon-with-value-div {
  display: flex;
  flex-direction: column;
}

.weather-data-page__other-condition-icon-with-value-value {
  text-align: center;
  font-weight: bold;
}

/* Specific layouts */
.weather-data-page__other-condition-content.flex-list {
  display: flex;
}

.weather-data-page__other-condition-content.grid-icon-and-value,
.weather-data-page__other-condition-content.grid-icon-and-two-values,
.weather-data-page__other-condition-content.grid-icon-and-three-values {
  display: grid;
  align-items: center;
  justify-items: center;
  width: 100%;
}

.weather-data-page__other-condition-content.grid-icon-and-two-values,
.weather-data-page__other-condition-content.grid-icon-and-three-values {
  /* grid-template-columns: min-content 1fr; */
  grid-template-columns: min-content;
}

.grid-icon-and-value .weather-data-page__other-condition-icon-div {
  grid-column: 1;
  grid-row: 1;
}

.grid-icon-and-value .weather-data-page__other-condition-value-div {
  grid-column: 1; /* or 2 */
  grid-row: 1;
}

.grid-icon-and-two-values .weather-data-page__other-condition-icon-div {
  grid-column: 1;
  grid-row: 1;
}

.grid-icon-and-three-values .weather-data-page__other-condition-icon-div {
  grid-column: 1;
  grid-row: 1/3;
}

.grid-icon-and-two-values .weather-data-page__other-condition-value-div,
.grid-icon-and-three-values .weather-data-page__other-condition-value-div {
  grid-column: 1; /* or 2 */
  grid-row: 1;
  align-self: end;
}

.grid-icon-and-two-values .weather-data-page__other-condition-value-div {
  grid-column: 1; /* or 2 */
  grid-row: 1;
  align-self: center;
}

.grid-icon-and-three-values
  .weather-data-page__other-condition-value-small-div:first-of-type {
  grid-column: 1; /* or 2 */
  grid-row: 2;
  align-self: start;
  width: 100%;
  border-top: 1px solid var(--col-dark-grey);
  display: flex;
  justify-content: center;
}

.grid-icon-and-two-values .weather-data-page__other-condition-value-small-div,
.grid-icon-and-three-values
  .weather-data-page__other-condition-value-small-div:last-of-type {
  grid-column: 1; /* or 1/3 */
  grid-row: 3;
  justify-self: start;
  align-self: end;
}
.grid-icon-and-two-values .weather-data-page__other-condition-value-small-div {
  grid-row: 2;
}

.grid-icon-and-two-values .weather-data-page__other-condition-value-small,
.grid-icon-and-three-values
  .weather-data-page__other-condition-value-small-div:last-of-type
  .weather-data-page__other-condition-value-small {
  font-weight: bold;
}

/* WEATHER ERROR PAGE ------------------------------------------------------------ */

main:has(> .error-page),
main:has(> .fetching-page),
main:has(> .locating-page) {
  flex: 1;
  overflow: hidden;
}

.error-page,
.fetching-page,
.locating-page {
  height: 100%;
}

.error-page__error-div,
.fetching-page__fetching-data-div,
.locating-page__locating-div {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.error-page__icon-div,
.fetching-page__icon-div,
.locating-page__icon-div {
  height: 100%;
  flex-grow: 1;
  min-height: 0;
}

.error-page__icon-div svg,
.fetching-page__icon-div svg,
.locating-page__icon-div svg {
  height: 100%;
  width: 100%;
  font-size: 3rem;
}

.error-page__error-msg,
.fetching-page__fetching-data-msg,
.locating-page__locating-msg {
  font-size: var(--txt-small-fontsize);
  text-wrap: balance;
  text-align: center;
}

/* Icons */
.select-location-page__search-icon,
.select-location-page__current-location-icon,
.select-location-page__remove-home-btn,
.select-location-page__remove-bookmarked-btn,
.select-location-page__settings-btn,
.settings-page__back-btn,
.error-page__back-btn,
.weather-data-page__back-btn,
.weather-data-page__refresh-btn,
.weather-data-page__alert-open-link-btn,
.weather-data-page__toggle-home-btn,
.weather-data-page__toggle-bookmarked-btn {
  width: var(--generic-icon-size);
  height: var(--generic-icon-size);
  border: none;
  background: none;
}

.select-location-page__search-icon svg,
.select-location-page__remove-current-location-icon svg,
.select-location-page__remove-home-btn svg,
.select-location-page__remove-bookmarked-btn svg,
.select-location-page__settings-btn svg,
.settings-page__back-btn svg,
.error-page__back-btn svg,
.weather-data-page__back-btn svg,
.weather-data-page__refresh-btn svg,
.weather-data-page__alert-open-link-btn svg,
.weather-data-page__toggle-home-btn svg,
.weather-data-page__toggle-bookmarked-btn svg {
  height: 100%;
  width: 100%;
}

.select-location-page__remove-home-btn path,
.weather-data-page__toggle-home-btn path {
  fill: red;
  stroke: red;
}

.select-location-page__current-location-icon path,
.select-location-page__search-icon path,
.select-location-page__remove-bookmarked-btn path,
.select-location-page__settings-btn path,
.settings-page__back-btn path,
.error-page__back-btn path,
.weather-data-page__back-btn path,
.weather-data-page__refresh-btn path,
.weather-data-page__alert-open-link-btn path,
.weather-data-page__toggle-bookmarked-btn path {
  fill: var(--col-txt);
  stroke: var(--col-txt);
}

.weather-data-page.night .weather-data-page__back-btn path,
.weather-data-page.night .weather-data-page__refresh-btn path,
.weather-data-page.night .weather-data-page__toggle-bookmarked-btn path {
  fill: var(--col-txt-alt);
  stroke: var(--col-txt-alt);
}

/* Main footer */
.main-footer {
  background-color: var(--block-bg-col);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--footer-gap);
  padding: var(--footer-padding);
}

.main-footer__api-credit {
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-footer__api-credit-img {
  width: min(15rem, calc(60 * var(--max-width)));
  height: auto;
}

.main-footer__img-credit {
  font-size: var(--txt-small-fontsize);
  color: var(--col-dark-grey);
}

.main-footer__img-credit a {
  font-weight: bold;
}

/* Hover */
.weather-data-page__day-forecasts-li:active,
.select-location-page__current-location-div:active,
.select-location-page__home-div:active,
.select-location-page__bookmarked-div:active {
  background-color: var(--col-highlight);
  transition: 0.5s;
}
.weather-data-page__day-forecasts-li:active {
  background-color: var(--col-white-alpha-x2);
  transition: 0.5s;
}
.weather-data-page__day-forecasts-li.displayed {
  background-color: var(--col-white);
  transition: 0.5s;
  pointer-events: none;
}
@media not all and (hover: none) {
  .weather-data-page__day-forecasts-li:hover,
  .select-location-page__current-location-div:hover,
  .select-location-page__home-div:hover,
  .select-location-page__bookmarked-div:hover {
    background-color: var(--col-highlight);
    transition: 0.5s;
  }
  .weather-data-page__day-forecasts-li:hover {
    background-color: var(--col-white-alpha-x2);
    transition: 0.5s;
  }
}

/* Customize scrollbars */
::-webkit-scrollbar {
  width: 4px; /* width of the entire scrollbar */
  height: 4px; /* height of the entire scrollbar */
}

::-webkit-scrollbar-track {
  background: transparent; /* color of the tracking area */
}

::-webkit-scrollbar-thumb {
  background: #888; /* color of the scroll thumb */
  border-radius: 2px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555; /* color of the scroll thumb on hover */
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,4BAA4B;EAC5B,oCAAoC;EACpC,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,mDAAmD;EACnD,gEAAgE;EAChE,6BAA6B;EAC7B,sCAAsC;;EAEtC,uBAAuB;EACvB,4BAA4B;EAC5B,kCAAkC;EAClC,mCAAmC;EACnC;;;;GAIC;EACD,wCAAwC;EACxC,iCAAiC;;EAEjC,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;;EAE/B,kBAAkB;;EAElB,gBAAgB;EAChB,iCAAiC;;EAEjC,eAAe;EACf,oBAAoB;EACpB,2BAA2B;EAC3B,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;EAC5B,8BAA8B;EAC9B,uCAAuC;EACvC,oCAAoC;EACpC,uCAAuC;EACvC,yCAAyC;EACzC,yBAAyB;EACzB,kCAAkC;;EAElC,mCAAmC;EACnC,oBAAoB;;EAEpB,+CAA+C;EAC/C,8BAA8B;;EAE9B,WAAW;EACX,cAAc;EACd,oBAAoB;;EAEpB,uCAAuC;EACvC,mBAAmB;EACnB,+BAA+B;EAC/B,wBAAwB;EACxB,4DAA4D;EAC5D,8CAA8C;EAC9C,wCAAwC;EACxC,oDAAoD;EACpD,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;;EAElB,wBAAwB;;EAExB,YAAY;EACZ;;gEAE8D;;EAE9D,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,yCAAyC;EACzC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;;;EAGE,oBAAoB;EACpB,kBAAkB,EAAE,SAAS;EAC7B,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,aAAa,EAAE,oCAAoC;EACnD,cAAc,EAAE,iBAAiB;;EAEjC,iCAAiC;EACjC,uBAAuB;EACvB,kBAAkB;;EAElB,WAAW;EACX,uDAAuD;;EAEvD,0BAA0B,EAAE,+CAA+C;EAC3E,iBAAiB;AACnB;;AAEA,sDAAsD;;AAEtD,eAAe;;AAEf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;EAEE,eAAe;AACjB;;AAEA,YAAY;;AAEZ;;;;;EAKE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;;;;EAKE,aAAa;EACb,4EAA4E;EAC5E,sEAAsE;EACtE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;;EAKE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,mFAAmF;;AAEnF;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;;;EAIE,qCAAqC;EACrC,4BAA4B;EAC5B,mCAAmC;EACnC,qBAAqB;EACrB,aAAa;AACf;;AAEA;;;;EAIE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;;;;EAIE,2CAA2C;EAC3C,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,4EAA4E;AAC5E,yEAAyE;;AAEzE;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;;EAEE,4BAA4B;EAC5B,6BAA6B;EAC7B,qCAAqC;EACrC,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,kCAAkC;EAClC,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,+BAA+B;EAC/B,UAAU;EACV,2CAA2C;AAC7C;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,kCAAkC;EAClC,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uCAAuC;EACvC,wCAAwC;EACxC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,4BAA4B;EAC5B,aAAa;AACf;;AAEA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;AACpB;;AAEA,mFAAmF;;AAEnF;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kEAAkE;EAClE;;;8EAG4E;EAC5E,sEAAsE;EACtE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,wGAAwG;AAC1G;;AAEA;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,sBAAsB;;AAEtB;EACE,YAAY;EACZ,mDAAmD;EACnD,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,iCAAiC;EACjC,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE;;;;6BAI2B;EAC3B,mEAAmE;EACnE,8CAA8C;AAChD;;AAEA;EACE;;;;kBAIgB;EAChB,mEAAmE;EACnE,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;EACxC,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE;IACE;;;6BAGyB;IACzB,uDAAuD;IACvD,0DAA0D;EAC5D;;EAEA;;IAEE,gCAAgC;IAChC,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,sCAAsC;IACtC,oBAAoB;EACtB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,sCAAsC;IACtC,oBAAoB;EACtB;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb;;eAEa;EACb,mCAAmC;EACnC,sCAAsC;EACtC,qCAAqC;EACrC,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;;EAE3B;;eAEa;EACb,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,kCAAkC;EAClC,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kHAAkH;;EAElH,gFAAgF;EAChF,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,cAAc;EACd,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA,mBAAmB;;AAEnB;;;EAGE,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA,6BAA6B;;AAE7B;;EAEE,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE;;;;UAIQ;EACR,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA;EACE;;;;;;UAMQ;EACR,0CAA0C;EAC1C,8CAA8C;EAC9C,wCAAwC;EACxC,wCAAwC;EACxC,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;;EAEE,eAAe;EACf,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,sCAAsC;EACtC,iEAAiE;AACnE;;AAEA;;EAEE,eAAe;EACf,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA,yBAAyB;;AAEzB;EACE,aAAa;EACb,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,4BAA4B;EAC5B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;EAEE,yDAAyD;AAC3D;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,gDAAgD;EAChD,aAAa;EACb,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;AACf;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;EAEE,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc,EAAE,SAAS;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,cAAc,EAAE,SAAS;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc,EAAE,SAAS;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,cAAc,EAAE,SAAS;EACzB,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,0CAA0C;EAC1C,aAAa;EACb,uBAAuB;AACzB;;AAEA;;;EAGE,cAAc,EAAE,WAAW;EAC3B,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;AACb;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA,oFAAoF;;AAEpF;;;EAGE,OAAO;EACP,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;EAGE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;;;EAGE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;;;EAGE,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,UAAU;AACV;;;;;;;;;;;;EAYE,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;EAYE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,SAAS;EACT,WAAW;AACb;;AAEA;;;;;;;;;;EAUE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;;EAGE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,qCAAqC;EACrC,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,UAAU;AACV;;;;EAIE,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE;;;;IAIE,sCAAsC;IACtC,gBAAgB;EAClB;EACA;IACE,2CAA2C;IAC3C,gBAAgB;EAClB;AACF;;AAEA,yBAAyB;AACzB;EACE,UAAU,EAAE,kCAAkC;EAC9C,WAAW,EAAE,mCAAmC;AAClD;;AAEA;EACE,uBAAuB,EAAE,+BAA+B;AAC1D;;AAEA;EACE,gBAAgB,EAAE,8BAA8B;EAChD,kBAAkB;AACpB;;AAEA;EACE,gBAAgB,EAAE,uCAAuC;AAC3D","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Nunito&display=swap\");\r\n\r\n:root {\r\n  /* Colors (palette)*/\r\n  --alpha: 0.3;\r\n  --col-black: rgb(20, 20, 20);\r\n  --col-light-grey: rgb(211, 211, 211);\r\n  --col-dark-grey: rgb(65, 65, 65);\r\n  --col-white: rgb(255, 255, 255);\r\n  --col-rain: rgb(0, 102, 204);\r\n  --col-white-alpha: rgb(255, 255, 255, var(--alpha));\r\n  --col-white-alpha-x2: rgb(255, 255, 255, calc(var(--alpha) * 2));\r\n  --col-alert: var(--col-white);\r\n  --col-alert-bg: rgba(220, 53, 69, 0.6);\r\n\r\n  /* Colors (background)*/\r\n  --bg-col: rgb(227, 248, 242);\r\n  --block-bg-col: rgb(215, 240, 233);\r\n  --col-highlight: rgb(188, 224, 232);\r\n  --weather-data-page-bg: linear-gradient(\r\n    to bottom,\r\n    var(--bg-col),\r\n    var(--col-dark-grey)\r\n  );\r\n  --block-bg-color: var(--col-white-alpha);\r\n  --main-grey: var(--col-dark-grey);\r\n\r\n  /* Colors (text/icons)*/\r\n  --col-txt: var(--col-black);\r\n  --col-txt-alt: var(--col-white);\r\n\r\n  /* Colors (icons)*/\r\n\r\n  /* Font family */\r\n  --main-font: \"Nunito\", sans-serif;\r\n\r\n  /* Font sizes */\r\n  --txt-fontsize: 18px;\r\n  --txt-small-fontsize: 0.8em;\r\n  --txt-smaller-fontsize: 0.6em;\r\n  --txt-lineheight: 1.2;\r\n  --h1-font-size: 1.2rem;\r\n  --h2-font-size: 2em;\r\n  --h3-font-size: 1.1em;\r\n  --h3-alert-font-size: 2em;\r\n  --h3-icon-size: 3em;\r\n  --h4-alert-font-size: var(--h3-font-size);\r\n  --weather-icon-size: 9em;\r\n  --weather-icon-mini-size: 2.5em;\r\n  --weather-icon-mid-size: 5em;\r\n  --temp-font-size: 5rem;\r\n  --temp-font-size-small: 4rem;\r\n  --temp-font-size-smaller: 3rem;\r\n  --other-condition-value-fontsize: 3.5em;\r\n  --other-condition-unit-fontsize: 1em;\r\n  --other-condition-small-fontsize: 0.8em;\r\n  --other-condition-smaller-fontsize: 0.6em;\r\n  --generic-icon-size: 2rem;\r\n  --select-location-text-size: 1.2em;\r\n\r\n  /* Text clamping: number of lines */\r\n  --alert-max-lines: 4;\r\n\r\n  /* Maximum width (including dashboard margin) */\r\n  --max-width: min(1440px, 100%);\r\n\r\n  /* Radius */\r\n  --radius: 30px;\r\n  --radius-inner: 25px;\r\n\r\n  /*Margins, gaps and paddings (+widths)*/\r\n  --page-padding: 1em;\r\n  --page-gap: var(--page-padding);\r\n  --block-alt-padding: 1em;\r\n  --block-half-alt-padding: calc(var(--block-alt-padding) / 2);\r\n  --block-alt-gap: var(--block-half-alt-padding);\r\n  --block-padding: calc(var(--radius) / 2);\r\n  --block-padding-inner: calc(var(--radius-inner) / 2);\r\n  --block-gap: 0.4em;\r\n  --block-gap-larger: 0.8em;\r\n  --select-location-padding: 0.5em 1em;\r\n  --select-location-gap: 1em;\r\n  --footer-padding: 3rem;\r\n  --footer-gap: 2rem;\r\n\r\n  /* Images / icons size */\r\n\r\n  /* Shadows */\r\n  /* --outset-shadow: 2px 2px 8px var(--col-accent-medium);\r\n    --outset-shadow-btn-active: 2px 2px 5px var(--col-accent-medium);\r\n    --inset-shadow: 2px 2px 2px var(--col-accent-light) inset; */\r\n\r\n  /* Animations on hover / active / ...*/\r\n  /* --transition-time: 0.8s; */\r\n}\r\n\r\nhtml {\r\n  background-color: var(--bg-col);\r\n  color: var(--col-txt);\r\n  font-family: var(--main-font), sans-serif;\r\n  font-weight: 400;\r\n  font-size: var(--txt-fontsize);\r\n  line-height: var(--txt-lineheight);\r\n}\r\n\r\nhtml:has(.weather-data-page) {\r\n  background: var(--weather-data-page-bg);\r\n  background-attachment: fixed;\r\n}\r\n\r\n*,\r\n*:before,\r\n*:after {\r\n  font-family: inherit;\r\n  font-size: inherit; /* 100% */\r\n  line-height: inherit;\r\n  color: inherit;\r\n  box-sizing: border-box;\r\n  padding: 0;\r\n  margin: 0;\r\n  vertical-align: baseline;\r\n  -webkit-tap-highlight-color: transparent;\r\n}\r\n\r\nbody {\r\n  margin: 0 auto;\r\n  height: 100vh; /*it is assumed the same for <html>*/\r\n  height: 100dvh; /* if supported */\r\n\r\n  /* if you want to allow scroll: */\r\n  /* min-height: 100vh; */\r\n  /* height: 100%; */\r\n\r\n  width: 100%;\r\n  /* or max-width -- this avoids horizontal scroll bars */\r\n\r\n  touch-action: manipulation; /* disable double tap to zoom on some browsers*/\r\n  user-select: none;\r\n}\r\n\r\n/*****************************************************/\r\n\r\n/* || Generic */\r\n\r\nbody {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  overflow: auto;\r\n}\r\n\r\nbody > * {\r\n  width: 100%;\r\n}\r\n\r\nmain {\r\n  width: 100%;\r\n  max-width: var(--max-width);\r\n  min-height: 100dvh;\r\n  flex-shrink: 0;\r\n  margin: 0 auto;\r\n}\r\n\r\np {\r\n  text-wrap: pretty;\r\n}\r\n\r\nul,\r\nol {\r\n  list-style: none;\r\n}\r\n\r\na,\r\na:hover,\r\na:active,\r\na:visited {\r\n  text-decoration: none;\r\n}\r\n\r\nbutton,\r\n.weather-data-page__day-forecasts-li {\r\n  cursor: pointer;\r\n}\r\n\r\n/* HEADERS */\r\n\r\n.select-location-page,\r\n.settings-page,\r\n.fetching-page,\r\n.error-page,\r\n.locating-page {\r\n  padding: var(--page-padding);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--page-gap);\r\n}\r\n\r\n.select-location-page__header,\r\n.settings-page__header,\r\n.error-page__header,\r\n.fetching-page__header,\r\n.locating-page__header {\r\n  display: grid;\r\n  grid-template-columns: var(--generic-icon-size) 1fr var(--generic-icon-size);\r\n  grid-template-rows: max(var(--h1-font-size), var(--generic-icon-size));\r\n  align-items: center;\r\n  justify-items: center;\r\n  line-height: 1;\r\n}\r\n\r\n.select-location-page__h1,\r\n.settings-page__h1,\r\n.fetching-page__h1,\r\n.error-page__h1,\r\n.locating-page__h1 {\r\n  font-size: var(--h1-font-size);\r\n  grid-column: 2;\r\n}\r\n\r\n/* SELECT LOCATION PAGE --------------------------------------------------------- */\r\n\r\n.select-location-page__bookmarked-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--block-gap);\r\n}\r\n\r\n.select-location-page__search-div,\r\n.select-location-page__home-div,\r\n.select-location-page__bookmarked-div,\r\n.select-location-page__current-location-div {\r\n  background-color: var(--block-bg-col);\r\n  border-radius: var(--radius);\r\n  /* padding: var(--block-padding); */\r\n  gap: var(--block-gap);\r\n  display: flex;\r\n}\r\n\r\n.select-location-page__search-icon,\r\n.select-location-page__remove-home-btn,\r\n.select-location-page__remove-bookmarked-btn,\r\n.select-location-page__current-location-icon {\r\n  margin: var(--block-padding);\r\n  margin-right: 0;\r\n}\r\n\r\n.select-location-page__search-input,\r\n.select-location-page__home-btn,\r\n.select-location-page__bookmarked-btn,\r\n.select-location-page__current-location-btn {\r\n  font-size: var(--select-location-text-size);\r\n  border: none;\r\n  background: none;\r\n  text-align: left;\r\n  justify-content: pretty;\r\n  padding: var(--block-padding);\r\n  padding-left: 0;\r\n  width: 100%;\r\n}\r\n\r\n.select-location-page__search-input {\r\n  padding: 0;\r\n  margin: var(--block-padding);\r\n  margin-left: 0;\r\n}\r\n\r\n.select-location-page__search-input {\r\n  width: 100%;\r\n  border-bottom: 1px solid var(--bg-col);\r\n}\r\n.select-location-page__search-input::placeholder {\r\n  color: var(--col-light-grey);\r\n}\r\n.select-location-page__search-input:focus {\r\n  /* border: none; */\r\n  outline: none;\r\n}\r\n\r\n.select-location-page__remove-home-btn,\r\n.select-location-page__remove-bookmarked-btn {\r\n  flex-basis: calc(var(--generic-icon-size));\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* SETTINGS PAGE --------------------------------------------------------- */\r\n/* See also: https://moderncss.dev/pure-css-custom-styled-radio-buttons/*/\r\n\r\n.settings-page__h2 {\r\n  text-align: center;\r\n}\r\n\r\n.settings-page__units-fieldset {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5em;\r\n}\r\n\r\n.settings-page__enable-animations-item-div,\r\n.settings-page__units-fieldset {\r\n  border-radius: var(--radius);\r\n  padding: var(--block-padding);\r\n  background-color: var(--block-bg-col);\r\n  border: none;\r\n}\r\n\r\n.settings-page__enable-animations-item-label,\r\n.settings-page__units-item-label {\r\n  width: 100%;\r\n}\r\n\r\n.settings-page__units-fieldset-legend {\r\n  border-radius: var(--radius);\r\n  padding: var(--block-padding-inner);\r\n  background-color: var(--col-white);\r\n  border: none;\r\n  font-weight: bold;\r\n}\r\n\r\n.settings-page__enable-animations-item-div,\r\n.settings-page__units-item-div {\r\n  display: grid;\r\n  grid-template-columns: 1em auto;\r\n  gap: 0.5em;\r\n  font-size: var(--select-location-text-size);\r\n}\r\n\r\ninput[type=\"radio\"],\r\ninput[type=\"checkbox\"] {\r\n  user-select: none;\r\n  cursor: pointer;\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  background-color: var(--col-white);\r\n  margin: 0;\r\n  font: inherit;\r\n  color: var(--col-white);\r\n  width: 1.15em;\r\n  height: 1.15em;\r\n  border: 0.15em solid var(--col-white);\r\n  transform: translateY(-0.075em);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\ninput[type=\"radio\"]::before,\r\ninput[type=\"checkbox\"]::before {\r\n  content: \"\";\r\n  width: 0.65em;\r\n  height: 0.65em;\r\n  transform: scale(0);\r\n  transition: 120ms transform ease-in-out;\r\n  box-shadow: inset 1em 1em var(--col-txt);\r\n  /* Windows High Contrast Mode */\r\n  background-color: CanvasText;\r\n}\r\n\r\ninput[type=\"radio\"]:checked::before,\r\ninput[type=\"checkbox\"]:checked::before {\r\n  transform: scale(1);\r\n}\r\n\r\ninput[type=\"radio\"]:focus,\r\ninput[type=\"checkbox\"]:focus {\r\n  border-color: var(--col-txt);\r\n  outline: none;\r\n}\r\n\r\ninput[type=\"radio\"],\r\ninput[type=\"radio\"]::before {\r\n  border-radius: 50%;\r\n}\r\ninput[type=\"checkbox\"],\r\ninput[type=\"checkbox\"]::before {\r\n  border-radius: 20%;\r\n}\r\n\r\n/* WEATHER DATA PAGE ------------------------------------------------------------ */\r\n\r\n.weather-data-page {\r\n  padding: var(--page-padding);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--page-gap);\r\n  padding-bottom: var(--footer-padding);\r\n}\r\n\r\n.weather-data-page__header {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  line-height: 1;\r\n  gap: var(--page-gap);\r\n}\r\n\r\n.weather-data-page__btn-div {\r\n  display: grid;\r\n  grid-template-areas: \"back time time time home bookmarked refresh\";\r\n  grid-template-columns:\r\n    var(--generic-icon-size) var(--generic-icon-size) var(--generic-icon-size)\r\n    1fr\r\n    var(--generic-icon-size) var(--generic-icon-size) var(--generic-icon-size);\r\n  grid-template-rows: max(var(--h1-font-size), var(--generic-icon-size));\r\n  align-items: center;\r\n  justify-items: center;\r\n  line-height: 1;\r\n  width: 100%;\r\n}\r\n\r\n.weather-data-page.daily .weather-data-page__btn-div {\r\n  grid-template-areas: \"back daily-forecast daily-forecast daily-forecast daily-forecast daily-forecast .\";\r\n}\r\n\r\n@media only screen and (min-width: 641px) {\r\n  .weather-data-page__btn-div {\r\n    grid-template-areas: \"back . . time home bookmarked refresh\";\r\n  }\r\n}\r\n\r\n.weather-data-page__last-update-time {\r\n  grid-area: time;\r\n}\r\n\r\n.weather-data-page__daily-forecast-p {\r\n  grid-area: daily-forecast;\r\n}\r\n\r\n.weather-data-page__back-btn {\r\n  grid-area: back;\r\n}\r\n\r\n.weather-data-page__refresh-btn {\r\n  grid-area: refresh;\r\n}\r\n\r\n.weather-data-page__toggle-home-btn {\r\n  grid-area: home;\r\n}\r\n\r\n.weather-data-page__toggle-bookmarked-btn {\r\n  grid-area: bookmarked;\r\n}\r\n\r\n.weather-data-page__location {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.weather-data-page__location-h2 {\r\n  font-size: var(--h2-font-size);\r\n  text-align: center;\r\n  text-wrap: balance;\r\n}\r\n\r\n/* CURRENT CONDITION */\r\n\r\n.weather-data-page.night {\r\n  --alpha: 0.5;\r\n  --col-white-alpha: rgb(255, 255, 255, var(--alpha));\r\n  --block-bg-color: var(--col-white-alpha);\r\n  --main-grey: var(--col-light-grey);\r\n}\r\n\r\n.weather-data-page.night .weather-data-page__header,\r\n.weather-data-page.night .weather-data-page__current-condition-div,\r\n.weather-data-page.night .weather-data-page__daily-condition-div {\r\n  color: var(--col-txt-alt);\r\n}\r\n\r\n.weather-data-page__current-condition-div,\r\n.weather-data-page__daily-condition-div {\r\n  display: grid;\r\n  padding: var(--block-alt-padding);\r\n  gap: var(--block-alt-gap) 0px;\r\n  align-items: center;\r\n  justify-items: center;\r\n  justify-content: center;\r\n  line-height: 1;\r\n}\r\n\r\n.weather-data-page__current-condition-div {\r\n  grid-template-areas:\r\n    \"conditions conditions\"\r\n    \"icon temp\"\r\n    \"feelslike feelslike\"\r\n    \"lowhightemp lowhightemp\";\r\n  grid-template-rows: max-content max-content max-content max-content;\r\n  grid-template-columns: max-content max-content;\r\n}\r\n\r\n.weather-data-page__daily-condition-div {\r\n  grid-template-areas:\r\n    \"date date\"\r\n    \"conditions conditions\"\r\n    \"icon hightemp\"\r\n    \"icon lowtemp\";\r\n  grid-template-rows: max-content max-content max-content max-content;\r\n  grid-template-columns: max-content max-content;\r\n}\r\n\r\n.weather-data-page__conditions-p {\r\n  grid-area: conditions;\r\n  color: var(--main-grey);\r\n}\r\n\r\n.weather-data-page__date-p {\r\n  grid-area: date;\r\n  font-weight: bold;\r\n}\r\n\r\n.weather-data-page__temp-p {\r\n  grid-area: temp;\r\n  justify-self: start;\r\n  font-size: var(--temp-font-size-small);\r\n  letter-spacing: -4px;\r\n  font-weight: bold;\r\n}\r\n\r\n.weather-data-page__high-temp-p {\r\n  grid-area: hightemp;\r\n  justify-self: start;\r\n  align-self: end;\r\n  font-size: var(--temp-font-size-small);\r\n  letter-spacing: -4px;\r\n  font-weight: bold;\r\n}\r\n\r\n.weather-data-page__low-temp-p {\r\n  margin-top: calc(-1 * var(--block-alt-gap) / 2);\r\n  grid-area: lowtemp;\r\n  justify-self: start;\r\n  align-self: start;\r\n  font-size: var(--temp-font-size-smaller);\r\n  letter-spacing: -3px;\r\n  color: var(--main-grey);\r\n}\r\n\r\n@media only screen and (min-width: 641px) {\r\n  .weather-data-page__daily-condition-div {\r\n    grid-template-areas:\r\n      \"date date date\"\r\n      \"conditions conditions conditions\"\r\n      \"icon hightemp lowtemp\";\r\n    grid-template-rows: max-content max-content max-content;\r\n    grid-template-columns: max-content max-content max-content;\r\n  }\r\n\r\n  .weather-data-page__temp-p,\r\n  .weather-data-page__high-temp-p {\r\n    font-size: var(--temp-font-size);\r\n    letter-spacing: -5px;\r\n  }\r\n\r\n  .weather-data-page__low-temp-p {\r\n    margin-top: 0;\r\n    font-size: var(--temp-font-size-small);\r\n    letter-spacing: -4px;\r\n  }\r\n\r\n  .weather-data-page__low-temp-p,\r\n  .weather-data-page__high-temp-p {\r\n    align-self: center;\r\n  }\r\n\r\n  .weather-data-page__low-temp-p::before {\r\n    content: \"\\00a0/\\00a0\";\r\n    font-size: var(--temp-font-size-small);\r\n    letter-spacing: -4px;\r\n  }\r\n}\r\n\r\n.weather-data-page__icon-div {\r\n  grid-area: icon;\r\n  justify-self: end;\r\n  width: var(--weather-icon-size);\r\n  height: var(--weather-icon-size);\r\n}\r\n\r\n.weather-data-page__feels-like-p {\r\n  grid-area: feelslike;\r\n}\r\n\r\n.weather-data-page__high-low-temp-p {\r\n  grid-area: lowhightemp;\r\n}\r\n\r\n/* ALERTS */\r\n\r\n.weather-data-page__alerts-div {\r\n  display: grid;\r\n  grid-template-areas:\r\n    \"icon titleh3\"\r\n    \"list list\";\r\n  grid-template-rows: max-content 1fr;\r\n  grid-template-columns: max-content 1fr;\r\n  background-color: var(--col-alert-bg);\r\n  border-radius: var(--radius);\r\n  padding: var(--block-padding);\r\n  gap: var(--block-padding) 0;\r\n\r\n  grid-template-areas:\r\n    \" titleh3 icon\"\r\n    \"list list\";\r\n  grid-template-columns: 1fr max-content;\r\n}\r\n\r\n.weather-data-page__alerts-icon-div {\r\n  grid-area: icon;\r\n  align-self: center;\r\n  width: var(--h3-icon-size);\r\n  height: var(--h3-icon-size);\r\n}\r\n\r\n.weather-data-page__alerts-icon-div path svg {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.weather-data-page__alerts-icon-div path {\r\n  fill: var(--col-alert);\r\n  stroke: var(--col-alert);\r\n}\r\n\r\n.weather-data-page__alerts-h3 {\r\n  grid-area: titleh3;\r\n  color: var(--col-alert);\r\n  font-weight: normal;\r\n  font-size: var(--h3-alert-font-size);\r\n  line-height: 1;\r\n  align-self: center;\r\n  margin-left: var(--block-padding-inner);\r\n}\r\n\r\n.weather-data-page__alerts-list {\r\n  grid-area: list;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--block-alt-gap);\r\n}\r\n\r\n.weather-data-page__alert-li {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: var(--block-bg-color);\r\n  border-radius: var(--radius-inner);\r\n  padding: var(--block-padding-inner);\r\n  gap: var(--block-gap);\r\n}\r\n\r\n.weather-data-page__alert-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  height: min-content;\r\n}\r\n\r\n.weather-data-page__alert-h4 {\r\n  font-size: var(--h4-alert-font-size);\r\n}\r\n\r\n.weather-data-page__alert-date-p {\r\n  color: var(--col-dark-grey);\r\n  font-size: var(--txt-small-fontsize);\r\n  text-align: right;\r\n  text-wrap: balance;\r\n}\r\n\r\n.weather-data-page__alert-descr-p {\r\n  text-wrap: pretty;\r\n  /* Break links */\r\n  /* From: https://stackoverflow.com/questions/5241369/word-wrap-a-link-so-it-doesnt-overflow-its-parent-div-width */\r\n\r\n  /* Warning: Needed for oldIE support, but words are broken up letter-by-letter */\r\n  -ms-word-break: break-all;\r\n  word-break: break-all;\r\n  /* Non standard for webkit */\r\n  word-break: break-word;\r\n  -webkit-hyphens: auto;\r\n  -moz-hyphens: auto;\r\n  -ms-hyphens: auto;\r\n  hyphens: auto;\r\n}\r\n\r\n.weather-data-page__alert-li.clamp .weather-data-page__alert-descr-p {\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n  overflow: auto;\r\n  line-clamp: var(--alert-max-lines);\r\n  -webkit-line-clamp: var(--alert-max-lines);\r\n}\r\n\r\n/* GENERIC BLOCKS */\r\n\r\n.weather-data-page__weather-insight-div,\r\n.weather-data-page__hourly-forecasts-div,\r\n.weather-data-page__daily-forecasts-div {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: var(--block-bg-color);\r\n  border-radius: var(--radius);\r\n  padding: var(--block-padding);\r\n  gap: var(--block-gap);\r\n  user-select: none;\r\n}\r\n\r\n.weather-data-page__weather-insight-h3,\r\n.weather-data-page__hourly-forecasts-h3,\r\n.weather-data-page__daily-forecasts-h3 {\r\n  font-size: var(--h3-font-size);\r\n}\r\n\r\n.weather-data-page.daily .weather-data-page__daily-forecasts-div {\r\n  background: none;\r\n  padding: 0;\r\n}\r\n\r\n.weather-data-page.daily .weather-data-page__daily-forecasts-h3 {\r\n  display: none;\r\n}\r\n\r\n/* HOURLY / DAILY FORECASTS */\r\n\r\n.weather-data-page__hourly-forecasts-list,\r\n.weather-data-page__daily-forecasts-list {\r\n  display: flex;\r\n  gap: var(--block-gap-larger);\r\n  overflow-x: auto;\r\n  overflow-y: hidden;\r\n  padding-bottom: var(--block-gap);\r\n  justify-content: space-between;\r\n}\r\n\r\n.weather-data-page__daily-forecasts-list {\r\n  gap: var(--block-alt-gap);\r\n}\r\n\r\n.weather-data-page__hour-forecasts-li,\r\n.weather-data-page__day-forecasts-li {\r\n  display: grid;\r\n  align-items: start;\r\n  justify-items: center;\r\n}\r\n\r\n.weather-data-page__hour-forecasts-li {\r\n  grid-template-areas:\r\n    \"temp\"\r\n    \"icon\"\r\n    \"precipprob\"\r\n    \"time\";\r\n  grid-template-rows: repeat(4, max-content);\r\n  grid-template-columns: repeat(24, min-content);\r\n}\r\n\r\n.weather-data-page__day-forecasts-li {\r\n  grid-template-areas:\r\n    \"temp\"\r\n    \"templow\"\r\n    \"icon\"\r\n    \"precipprob\"\r\n    \"time\"\r\n    \"date\";\r\n  grid-template-rows: repeat(6, max-content);\r\n  grid-template-columns: repeat(15, min-content);\r\n  background-color: var(--col-white-alpha);\r\n  border-radius: calc(var(--radius-inner));\r\n  padding: var(--block-padding-inner);\r\n  user-select: none;\r\n}\r\n\r\n.weather-data-page__hour-forecasts-temp,\r\n.weather-data-page__day-forecasts-temp-high {\r\n  grid-area: temp;\r\n  font-weight: bold;\r\n}\r\n\r\n.weather-data-page__day-forecasts-temp-low {\r\n  grid-area: templow;\r\n  font-size: var(--txt-small-fontsize);\r\n}\r\n\r\n.weather-data-page__hour-forecasts-icon-div,\r\n.weather-data-page__day-forecasts-icon-div {\r\n  grid-area: icon;\r\n  width: var(--weather-icon-mini-size);\r\n  height: var(--weather-icon-mini-size);\r\n}\r\n\r\n.weather-data-page__hour-forecasts-precip-prob,\r\n.weather-data-page__day-forecasts-precip-prob {\r\n  grid-area: precipprob;\r\n  color: var(--col-rain);\r\n  font-size: var(--txt-smaller-fontsize);\r\n  height: calc(var(--txt-smaller-fontsize) * var(--txt-lineheight));\r\n}\r\n\r\n.weather-data-page__hour-forecasts-hour,\r\n.weather-data-page__day-forecasts-day {\r\n  grid-area: time;\r\n  font-size: var(--txt-small-fontsize);\r\n  padding-top: var(--block-gap-larger);\r\n}\r\n\r\n.weather-data-page__day-forecasts-date {\r\n  grid-area: date;\r\n  font-size: var(--txt-smaller-fontsize);\r\n}\r\n\r\n/* OTHER INFO FORECASTS */\r\n\r\n.weather-data-page__other-conditions-list {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: var(--block-gap-larger);\r\n  /* align-items: flex-start; */\r\n}\r\n\r\n.weather-data-page__other-condition-li {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: var(--block-bg-color);\r\n  border-radius: var(--radius);\r\n  padding: var(--block-padding);\r\n  gap: var(--block-gap);\r\n  user-select: none;\r\n  width: max-content;\r\n  flex: 1;\r\n  /* max-width: fit-content; */\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.weather-data-page__other-condition-li:has(.flex-list) {\r\n  flex: 3;\r\n}\r\n\r\n.weather-data-page__other-condition-h3 {\r\n  font-size: var(--h3-font-size);\r\n  text-align: center;\r\n}\r\n\r\n.weather-data-page__other-condition-content {\r\n  flex: 1;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.weather-data-page__other-condition-icon-div {\r\n  width: var(--weather-icon-mid-size);\r\n  height: min-content;\r\n  z-index: -1;\r\n}\r\n\r\n.weather-data-page__other-condition-value-div {\r\n  width: fit-content;\r\n  height: fit-content;\r\n  display: flex;\r\n  align-items: baseline;\r\n}\r\n\r\n.weather-data-page__other-condition-value {\r\n  font-weight: bold;\r\n  font-size: var(--other-condition-value-fontsize);\r\n}\r\n\r\n.x3 .weather-data-page__other-condition-value {\r\n  font-size: calc(var(--other-condition-value-fontsize) / 1.3);\r\n}\r\n\r\n.x4 .weather-data-page__other-condition-value {\r\n  font-size: calc(var(--other-condition-value-fontsize) / 1.6);\r\n}\r\n\r\n.x5 .weather-data-page__other-condition-value {\r\n  font-size: calc(var(--other-condition-value-fontsize) / 2);\r\n}\r\n\r\n.weather-data-page__other-condition-value-unit {\r\n  font-size: var(--other-condition-unit-fontsize);\r\n}\r\n\r\n.x3 .weather-data-page__other-condition-value-unit,\r\n.x4 .weather-data-page__other-condition-value-unit {\r\n  font-size: calc(var(--other-condition-unit-fontsize) / 1);\r\n}\r\n\r\n.x5 .weather-data-page__other-condition-value-unit {\r\n  font-size: calc(var(--other-condition-unit-fontsize) / 1);\r\n}\r\n\r\n.weather-data-page__other-condition-value-small-div {\r\n  font-size: var(--other-condition-small-fontsize);\r\n  display: flex;\r\n  gap: 0.2em;\r\n  width: max-content;\r\n}\r\n\r\n.weather-data-page__other-condition-icon-with-value-div {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.weather-data-page__other-condition-icon-with-value-value {\r\n  text-align: center;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Specific layouts */\r\n.weather-data-page__other-condition-content.flex-list {\r\n  display: flex;\r\n}\r\n\r\n.weather-data-page__other-condition-content.grid-icon-and-value,\r\n.weather-data-page__other-condition-content.grid-icon-and-two-values,\r\n.weather-data-page__other-condition-content.grid-icon-and-three-values {\r\n  display: grid;\r\n  align-items: center;\r\n  justify-items: center;\r\n  width: 100%;\r\n}\r\n\r\n.weather-data-page__other-condition-content.grid-icon-and-two-values,\r\n.weather-data-page__other-condition-content.grid-icon-and-three-values {\r\n  /* grid-template-columns: min-content 1fr; */\r\n  grid-template-columns: min-content;\r\n}\r\n\r\n.grid-icon-and-value .weather-data-page__other-condition-icon-div {\r\n  grid-column: 1;\r\n  grid-row: 1;\r\n}\r\n\r\n.grid-icon-and-value .weather-data-page__other-condition-value-div {\r\n  grid-column: 1; /* or 2 */\r\n  grid-row: 1;\r\n}\r\n\r\n.grid-icon-and-two-values .weather-data-page__other-condition-icon-div {\r\n  grid-column: 1;\r\n  grid-row: 1;\r\n}\r\n\r\n.grid-icon-and-three-values .weather-data-page__other-condition-icon-div {\r\n  grid-column: 1;\r\n  grid-row: 1/3;\r\n}\r\n\r\n.grid-icon-and-two-values .weather-data-page__other-condition-value-div,\r\n.grid-icon-and-three-values .weather-data-page__other-condition-value-div {\r\n  grid-column: 1; /* or 2 */\r\n  grid-row: 1;\r\n  align-self: end;\r\n}\r\n\r\n.grid-icon-and-two-values .weather-data-page__other-condition-value-div {\r\n  grid-column: 1; /* or 2 */\r\n  grid-row: 1;\r\n  align-self: center;\r\n}\r\n\r\n.grid-icon-and-three-values\r\n  .weather-data-page__other-condition-value-small-div:first-of-type {\r\n  grid-column: 1; /* or 2 */\r\n  grid-row: 2;\r\n  align-self: start;\r\n  width: 100%;\r\n  border-top: 1px solid var(--col-dark-grey);\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.grid-icon-and-two-values .weather-data-page__other-condition-value-small-div,\r\n.grid-icon-and-three-values\r\n  .weather-data-page__other-condition-value-small-div:last-of-type {\r\n  grid-column: 1; /* or 1/3 */\r\n  grid-row: 3;\r\n  justify-self: start;\r\n  align-self: end;\r\n}\r\n.grid-icon-and-two-values .weather-data-page__other-condition-value-small-div {\r\n  grid-row: 2;\r\n}\r\n\r\n.grid-icon-and-two-values .weather-data-page__other-condition-value-small,\r\n.grid-icon-and-three-values\r\n  .weather-data-page__other-condition-value-small-div:last-of-type\r\n  .weather-data-page__other-condition-value-small {\r\n  font-weight: bold;\r\n}\r\n\r\n/* WEATHER ERROR PAGE ------------------------------------------------------------ */\r\n\r\nmain:has(> .error-page),\r\nmain:has(> .fetching-page),\r\nmain:has(> .locating-page) {\r\n  flex: 1;\r\n  overflow: hidden;\r\n}\r\n\r\n.error-page,\r\n.fetching-page,\r\n.locating-page {\r\n  height: 100%;\r\n}\r\n\r\n.error-page__error-div,\r\n.fetching-page__fetching-data-div,\r\n.locating-page__locating-div {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.error-page__icon-div,\r\n.fetching-page__icon-div,\r\n.locating-page__icon-div {\r\n  height: 100%;\r\n  flex-grow: 1;\r\n  min-height: 0;\r\n}\r\n\r\n.error-page__icon-div svg,\r\n.fetching-page__icon-div svg,\r\n.locating-page__icon-div svg {\r\n  height: 100%;\r\n  width: 100%;\r\n  font-size: 3rem;\r\n}\r\n\r\n.error-page__error-msg,\r\n.fetching-page__fetching-data-msg,\r\n.locating-page__locating-msg {\r\n  font-size: var(--txt-small-fontsize);\r\n  text-wrap: balance;\r\n  text-align: center;\r\n}\r\n\r\n/* Icons */\r\n.select-location-page__search-icon,\r\n.select-location-page__current-location-icon,\r\n.select-location-page__remove-home-btn,\r\n.select-location-page__remove-bookmarked-btn,\r\n.select-location-page__settings-btn,\r\n.settings-page__back-btn,\r\n.error-page__back-btn,\r\n.weather-data-page__back-btn,\r\n.weather-data-page__refresh-btn,\r\n.weather-data-page__alert-open-link-btn,\r\n.weather-data-page__toggle-home-btn,\r\n.weather-data-page__toggle-bookmarked-btn {\r\n  width: var(--generic-icon-size);\r\n  height: var(--generic-icon-size);\r\n  border: none;\r\n  background: none;\r\n}\r\n\r\n.select-location-page__search-icon svg,\r\n.select-location-page__remove-current-location-icon svg,\r\n.select-location-page__remove-home-btn svg,\r\n.select-location-page__remove-bookmarked-btn svg,\r\n.select-location-page__settings-btn svg,\r\n.settings-page__back-btn svg,\r\n.error-page__back-btn svg,\r\n.weather-data-page__back-btn svg,\r\n.weather-data-page__refresh-btn svg,\r\n.weather-data-page__alert-open-link-btn svg,\r\n.weather-data-page__toggle-home-btn svg,\r\n.weather-data-page__toggle-bookmarked-btn svg {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.select-location-page__remove-home-btn path,\r\n.weather-data-page__toggle-home-btn path {\r\n  fill: red;\r\n  stroke: red;\r\n}\r\n\r\n.select-location-page__current-location-icon path,\r\n.select-location-page__search-icon path,\r\n.select-location-page__remove-bookmarked-btn path,\r\n.select-location-page__settings-btn path,\r\n.settings-page__back-btn path,\r\n.error-page__back-btn path,\r\n.weather-data-page__back-btn path,\r\n.weather-data-page__refresh-btn path,\r\n.weather-data-page__alert-open-link-btn path,\r\n.weather-data-page__toggle-bookmarked-btn path {\r\n  fill: var(--col-txt);\r\n  stroke: var(--col-txt);\r\n}\r\n\r\n.weather-data-page.night .weather-data-page__back-btn path,\r\n.weather-data-page.night .weather-data-page__refresh-btn path,\r\n.weather-data-page.night .weather-data-page__toggle-bookmarked-btn path {\r\n  fill: var(--col-txt-alt);\r\n  stroke: var(--col-txt-alt);\r\n}\r\n\r\n/* Main footer */\r\n.main-footer {\r\n  background-color: var(--block-bg-col);\r\n  margin: 0 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: var(--footer-gap);\r\n  padding: var(--footer-padding);\r\n}\r\n\r\n.main-footer__api-credit {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.main-footer__api-credit-img {\r\n  width: min(15rem, calc(60 * var(--max-width)));\r\n  height: auto;\r\n}\r\n\r\n.main-footer__img-credit {\r\n  font-size: var(--txt-small-fontsize);\r\n  color: var(--col-dark-grey);\r\n}\r\n\r\n.main-footer__img-credit a {\r\n  font-weight: bold;\r\n}\r\n\r\n/* Hover */\r\n.weather-data-page__day-forecasts-li:active,\r\n.select-location-page__current-location-div:active,\r\n.select-location-page__home-div:active,\r\n.select-location-page__bookmarked-div:active {\r\n  background-color: var(--col-highlight);\r\n  transition: 0.5s;\r\n}\r\n.weather-data-page__day-forecasts-li:active {\r\n  background-color: var(--col-white-alpha-x2);\r\n  transition: 0.5s;\r\n}\r\n.weather-data-page__day-forecasts-li.displayed {\r\n  background-color: var(--col-white);\r\n  transition: 0.5s;\r\n  pointer-events: none;\r\n}\r\n@media not all and (hover: none) {\r\n  .weather-data-page__day-forecasts-li:hover,\r\n  .select-location-page__current-location-div:hover,\r\n  .select-location-page__home-div:hover,\r\n  .select-location-page__bookmarked-div:hover {\r\n    background-color: var(--col-highlight);\r\n    transition: 0.5s;\r\n  }\r\n  .weather-data-page__day-forecasts-li:hover {\r\n    background-color: var(--col-white-alpha-x2);\r\n    transition: 0.5s;\r\n  }\r\n}\r\n\r\n/* Customize scrollbars */\r\n::-webkit-scrollbar {\r\n  width: 4px; /* width of the entire scrollbar */\r\n  height: 4px; /* height of the entire scrollbar */\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: transparent; /* color of the tracking area */\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: #888; /* color of the scroll thumb */\r\n  border-radius: 2px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #555; /* color of the scroll thumb on hover */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
